import React from 'react';
import * as styles from 'modules/admin/styles/StatusDot.styles';
interface Props {
  status: boolean;
}

export const StatusDot: React.FC<Props> = ({ status }) => {
  return <div css={status ? styles.active : styles.inactive} />;
};
